function Dashboard() {
  return (
    <div style={{ padding: 20 }}>
      <h1>📚 Library Management Dashboard</h1>
      <p>Welcome to the admin panel.</p>
    </div>
  );
}

export default Dashboard;